export interface ScoringItem {
  title: string;
  points: Array<{
    value: string;
    description: string;
  }>;
}

export const scoringItems: ScoringItem[] = [
  {
    title: '- ONLY ONE WINNER -',
    points: [
      { value: '10 points', description: 'awarded to the winner' },
      { value: '2 points', description: 'awarded to the loser' },
    ],
  },
  {
    title: '- EQUALLY MATCHED -',
    points: [
      { value: '5 points', description: 'awarded to each fighter in a draw' },
    ],
  },
  {
    title: '- UNFORESEEN OUTCOMES -',
    points: [
      {
        value: '2 points',
        description: 'for both fighters in any other outcome (including NC)',
      },
    ],
  },
  {
    title: '- NO JUDGES NEEDED -',
    points: [
      { value: '5 points', description: 'for a finish (submission, KO/TKO)' },
    ],
  },
  {
    title: '- GOES THE DISTANCE -',
    points: [
      { value: '2 points', description: 'for a unanimous decision' },
      { value: '1 point', description: 'each for a majority/split decision' },
    ],
  },
  {
    title: '- FLAWLESS VICTORY -',
    points: [
      { value: '2 points', description: 'for a 1st round finish' },
      {
        value: '2 points',
        description: 'for a finish in the 1st minute (stackable)',
      },
    ],
  },
  {
    title: '- BONUS TIME -',
    points: [{ value: '3 points', description: 'for a POTN or FOTN bonus' }],
  },
  {
    title: '- HOT STREAK -',
    points: [
      {
        value: '1-4 points',
        description: 'for the fighter depending on win streak',
      },
    ],
  },
];
